import { combineReducers } from 'redux';
import token from './token';
import exchange from './exchange';
import common from './common';


export const reducer = combineReducers({
  token,
  exchange,
  common
});
